import axios from 'axios';

const noop = () => {};

const http = {
  get: (...args) => axios.get(...args),
  post: (...args) => {
    setupCsrf();
    return axios.post(...args);
  },
  delete: (...args) => {
    setupCsrf();
    return axios.delete(...args);
  },
  put: (...args) => {
    setupCsrf();
    return axios.put(...args);
  },
  uploadFile: (endpoint, file, onProgress = noop) => {
    setupCsrf();
    const formData = new FormData();

    formData.append('file', file);

    return axios.post(endpoint, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      onUploadProgress: onProgress
    });
  },
  postForm: (endpoint, formParams, onProgress = noop) => {
    setupCsrf();
    const formData = new FormData();

    Object.keys(formParams).forEach(key => {
      formData.append(key, formParams[key]);
    });

    return axios.post(endpoint, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      onUploadProgress: onProgress
    });
  }
};

const setupCsrf = () => {
  // Copied from app_config.js
  // TODO: copy over humps (or not)
  const csrfElement = document.querySelector('meta[name=csrf-token]');
  // not there in tests
  if (csrfElement) {
    axios.defaults.headers.common['X-CSRF-Token'] = csrfElement.getAttribute(
      'content'
    );
  }
};

export default http;
